<script setup>
import { ref } from 'vue'	
</script>

<template>
    <section id="final-step" class="flex-1 h-full py-10">
        <div class="container mx-auto p-6 flex flex-col md:flex-row justify-around items-center h-full">
            <div class="w-12/12 md:w-5/12 max-w-[456px] shadow-sm">
                <div class="text-4xl text-white font-bold font-poppins mb-6">
                    <img src="@/assets/img/site/logo-programas-final-step.png" alt="">
                </div>
            </div>

            <div class="w-12/12 md:w-5/12 py-16">
                <h1 class="text-4xl text-purple-800 font-bold font-poppins mb-6">Parabéns por se inscrever no programa
                    In.pulse!</h1>
                <p>
                    Seu projeto será avaliado pela nossa rede de pareceristas e o resultado será divulgado nesta plataforma
                    e para o seu e-mail dentro da data prevista no edital.
                </p>
                <router-link :to="{ name: 'painel-proponente' }" class="no-underline">
                    <button type="button" class="btn medium primary mt-8">
                        Acessar meu painel
                    </button>
                </router-link>
            </div>
        </div>
    </section>
</template>

<style></style>
